module.exports = __webpack_public_path__ + "media/images/logo/logo_chariloto_select-62d7e7536bfa71fc25691685ce76c8ba.svg";